import React from "react";
import * as api from "../api";
import toast from "react-hot-toast";
import { DateFormatter2 } from "../../helpers/DateFormatter2";
import {
  faCalendarTimes,
  faSkullCrossbones,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomToast from "../../components/CustomToast";
import dayjs from "dayjs";

export const CREATE_SAHAKARI = "CREATE_SAHAKARI";
export const GET_SAHAKARI_SUCCESS = "GET_SAHAKARI_SUCCESS";
export const GET_SAHAKARI_FAILURE = "GET_SAHAKARI_FAILURE";
export const GET_INDIVIDUAL_SAHAKARI = "GET_INDIVIDUAL_SAHAKARI";
export const CLEAR_INDIVIDUAL_SAHAKARI = "CLEAR_INDIVIDUAL_SAHAKARI";
export const GET_SAHAKARI_MAIN_BRANCH = "GET_SAHAKARI_MAIN_BRANCH";
export const CLEAR_SAHAKARI_MAIN_BRANCH = "CLEAR_SAHAKARI_MAIN_BRANCH";
export const CLEAR_SAHAKARI = "CLEAR_SAHAKARI";
export const GET_SAHAKARI_STATS = "GET_SAHAKARI_STATS";

export const createSahakari =
  (payload, handleSuccess, handleFailure) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();

      const response = await api.apiCreateSahakari(payload, accessToken);
      handleSuccess();
    } catch (err) {
      handleFailure(err);
    }
  };

export const getSahakari = () => async (dispatch, getState) => {
  try {
    const {
      user: { accessToken },
    } = getState();
    const response = await api.apiGetSahakari(accessToken);
    //modify the result later here
    let dataArray = [];
    response.data.forEach((item) => {
      const formattedDate =
        item.sahakari.expirationDate === null
          ? "-"
          : DateFormatter2(item.sahakari.expirationDate);
      const tempArray = [
        item?.sahakari?.id,
        item?.username,
        item?.sahakari?.name,
        // item?.email,
        item?.mobileNumber,
        item?.sahakari?.location,
        formattedDate,
        item.sahakari?.isActive === true ? "Active" : "InActive",
        item.sahakari?.mainBranch === "SELF"
          ? "Main Office"
          : item.sahakari.mainBranch,
      ];
      dataArray = [...dataArray, tempArray];
    });
    dispatch({ type: GET_SAHAKARI_SUCCESS, payload: dataArray });
  } catch (err) {
    toast.error("Error getting Sahakari. Please refresh");
  }
};
export const getSahakariById =
  (id, handleSuccess, handleFailure) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiGetSahakariById(accessToken, id);
      dispatch({ type: GET_INDIVIDUAL_SAHAKARI, payload: response.data[0] });
      handleSuccess(response.data[0]);
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
      handleFailure();
    }
  };

export const clearIndividualSahakari = () => {
  return { type: CLEAR_INDIVIDUAL_SAHAKARI };
};

export const deleteSahakariById =
  (sahakariId, handleSuccess, handleFailure) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiDeleteSahakariById(accessToken, sahakariId);
      toast.success("Successfully deleted Sahakari");

      handleSuccess();
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);

      handleFailure();
    }
  };

export const updateSahakari =
  (payload, handleSuccess, handleFailure) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiUpdateSahakari(accessToken, payload);
      handleSuccess();
      toast.success("Sahakari has successfully been Updated");
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
      handleFailure();
    }
  };

export const getSahakariMainBranch = () => async (dispatch, getState) => {
  try {
    const {
      user: { accessToken },
    } = getState();
    const response = await api.apiGetSahakariMainBranch(accessToken);
    dispatch({ type: GET_SAHAKARI_MAIN_BRANCH, payload: response.data });
  } catch (err) {
    toast.error(err.response ? err.response.data?.message : err.message);
  }
};

export const clearSahakariMainBranch = () => {
  return { type: CLEAR_SAHAKARI_MAIN_BRANCH };
};

export const clearSahakari = () => {
  return { type: CLEAR_SAHAKARI };
};

export const addSahakariCustomerByCsv =
  (sahakariId, payload, handleSuccess, handleFailure) =>
  async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiAddSahakariCustomersCsv(
        accessToken,
        sahakariId,
        payload
      );
      toast.success("Successfully added Sahakari Customers");

      handleSuccess();
    } catch (err) {
      toast.error(err.response ? err.response?.data?.message : err?.message);

      handleFailure();
    }
  };

export const getSahakariDashboardStats = () => async (dispatch, getState) => {
  try {
    const {
      user: { accessToken },
    } = getState();

    const response = await api.apiGetSahakariStats(accessToken);
    dispatch({
      type: GET_SAHAKARI_STATS,
      payload: response.data.result,
    });
  } catch (err) {
    toast.error(err.response ? err.response?.data?.message : err?.message);
  }
};

export const getSahakariSubStatus = () => async (dispatch, getState) => {
  try {
    const {
      user: { accessToken },
    } = getState();
    const { data } = await api.apiGetSahakariSubscriptionStatus(accessToken);
    const daysToActualExpire =
      Number(data?.result?.daysToActualExpire ?? 0) ?? 0;

    if (daysToActualExpire < 7)
      CustomToast({
        title: `Your account is going to expire in ${daysToActualExpire} days.`,
        fontawesomeIcon: faCalendarTimes,
        toastType: "error",
        position: "bottom-right",
      });

    if (daysToActualExpire > 7 && daysToActualExpire < 14)
      CustomToast({
        title: `Your account is going to expire in ${dayjs(
          data?.result?.subscriptionExpirationDate
        ).format("MMMM DD, YYYY")}.`,
        fontawesomeIcon: faCalendarTimes,
        toastType: "warning",
        position: "bottom-right",
      });
  } catch (err) {
    console.log(err);
  }
};
